module.exports = __webpack_public_path__ + "static/media/potrait.fbcbe7ca.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Images/potrait.webp
// module id = 24
// module chunks = 2